export const returnFirstArg = value => value;
